export const ErrorBoundaryFallback = () => {
  return (
    <main className="bg-slate-800 flex h-screen flex-col items-center justify-center">
      <h2 className="mb-10 text-2xl">Something went terribly wrong!</h2>
    </main>
  );
};
